import { render } from "./access-list-guard.vue?vue&type=template&id=b28b7490&ts=true"
import script from "./access-list-guard.vue?vue&type=script&lang=ts"
export * from "./access-list-guard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__